import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    Box,
    IconButton,
    Typography,
    InputBase,
    Paper,
    Menu,
    MenuItem,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Button,
    Stack,
    Badge,
    Popover,
    Divider,
    Fade,
    Chip
} from "@mui/material";

import { useEffect } from "react";
import { ref, get } from "firebase/database";
import { rtdb } from "../services/firebase";

import { motion, AnimatePresence } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";

import { Link } from "react-router-dom";
import {
    FaSearch,
    FaShoppingCart,
    FaBars,
    FaUserCircle,
    FaChevronRight,
} from "react-icons/fa";

import LogoHeader from "../assets/logoheader.png";

import { useNavigate } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

const Header = () => {

    const { user, logout, searchBar, setSearchBar, cartCount } = useAuth();

    const navigate = useNavigate();

    const [anchorProducts, setAnchorProducts] = useState(null);
    const [anchorCart, setAnchorCart] = useState(null);
    const [anchorUser, setAnchorUser] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);

    const handleProductsOpen = (e) => setAnchorProducts(e.currentTarget);
    const handleProductsClose = () => setAnchorProducts(null);

    const handleCartOpen = (e) => setAnchorCart(e.currentTarget);
    const handleCartClose = () => setAnchorCart(null);

    const handleUserOpen = (e) => setAnchorUser(e.currentTarget);
    const handleUserClose = () => setAnchorUser(null);

    const isAdmin = user?.role === "admin";
    const isClient = user?.role === "client";
    const showAreaCliente = !!user && (isClient || isAdmin);

    const ORANGE_GRADIENT = "linear-gradient(135deg, #ff7a00, #ff9a00)";


    const drawerVariants = {
        hidden: { x: "100%", opacity: 0 },
        visible: {
            x: 0,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 260,
                damping: 28,
                when: "beforeChildren",
                staggerChildren: 0.08,
            },
        },
        exit: {
            x: "100%",
            opacity: 0,
            transition: { duration: 0.25, ease: "easeInOut" },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, x: 20 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.35, ease: "easeOut" },
        },
    };

    useEffect(() => {

        async function loadFilters() {

            try {

                const snapshot = await get(ref(rtdb, "app"));

                if (!snapshot.exists()) return;

                const data = snapshot.val();

                const brandsArray = data.brands
                    ? Object.values(data.brands)
                    : [];

                const categoriesArray = data.category
                    ? Object.values(data.category)
                    : [];

                setBrands(brandsArray);
                setCategories(categoriesArray);
            } catch (err) {
                console.error("Erro ao carregar filtros:", err);
            }
        }

        loadFilters();

    }, []);

    const search = () => {
        if (!searchBar) {
            return;
        }
        navigate("/produtos");
    };

    const renderUserHeader = () => {
        if (!user) return null;

        return (
            <Box
                sx={{
                    display: "block",
                    justifyContent: "center",

                    gap: 1,
                    px: 1,
                    pb: 1.2,
                    mb: 0.5,
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                }}
            >
                {isAdmin && (
                    <Chip
                        label="ADM"
                        size="small"
                        sx={{
                            height: 22,
                            fontWeight: 900,
                            borderRadius: "10px",
                            color: "#fff",
                            marginBottom: 1,
                            background: ORANGE_GRADIENT,
                            boxShadow: "0 6px 14px rgba(255, 122, 0, 0.25)",
                            "& .MuiChip-label": { px: 1 },
                        }}
                    />
                )}

                <Box sx={{ lineHeight: 1.05 }}>
                    <Typography sx={{ fontWeight: 900, fontSize: 15 }}>
                        {isClient ? (user?.name || "Minha Conta") : (user?.name || "Administrador")}
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "rgba(0,0,0,0.55)", mt: 0.2 }}>
                        {isAdmin ? "Acesso administrativo" : "Bem-vindo(a) de volta!"}
                    </Typography>
                </Box>
            </Box>
        );
    };

    return (
        <AppBar
            position="sticky"
            sx={{
                backgroundColor: "var(--azul)",
                paddingY: "8px",
                boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                zIndex: 999,
            }}
        >
            <Toolbar
                sx={{
                    maxWidth: "1400px",
                    width: "95%",
                    margin: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 3,
                }}
            >
                {/* LOGO */}
                <Box component={Link} to="/" sx={{ display: "flex" }}>
                    <img src={LogoHeader} alt="EMMA" style={{ height: 40 }} />
                </Box>

                {/* SEARCH BAR */}
                <Paper
                    sx={{
                        display: { xs: "none", md: "flex" },
                        alignItems: "center",
                        flex: 1,
                        maxWidth: "480px",
                        minWidth: "200px",
                        height: "40px",
                        paddingLeft: 1,
                        borderRadius: "14px",
                        overflow: "hidden",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.18)",
                        transition: "0.2s ease",
                        "&:focus-within": {
                            boxShadow: "0 0 10px rgba(255,255,255,0.35)",
                        },
                    }}
                >
                    <InputBase
                        placeholder="Buscar produtos, sabores, marcas..."
                        sx={{
                            flex: 1,
                            fontSize: 14,
                            paddingLeft: 1,
                        }}
                        value={searchBar}
                        onChange={(e) => {
                            setSearchBar(e.target.value);
                        }}
                    />
                    <IconButton
                        sx={{
                            backgroundColor: "#1c64f2",
                            height: "40px",
                            width: "46px",
                            borderRadius: 0,
                        }}
                        onClick={search}
                    >
                        <FaSearch color="white" />
                    </IconButton>
                </Paper>

                {/* NAVIGATION DESKTOP */}
                <Stack
                    direction="row"
                    spacing={3}
                    alignItems="center"
                    sx={{
                        display: { xs: "none", md: "flex" },
                    }}
                >
                    <Typography
                        component={Link}
                        to="/"
                        sx={{ color: "white", fontWeight: 600, textDecoration: "none" }}
                    >
                        Home
                    </Typography>

                    {/*  DROPDOWN */}
                    <Typography
                        sx={{ color: "white", fontWeight: 600, cursor: "pointer", textDecoration: "none" }}
                        onClick={handleProductsOpen}
                    >
                        Produtos ▾
                    </Typography>

                    <Menu
                        anchorEl={anchorProducts}
                        open={Boolean(anchorProducts)}
                        onClose={handleProductsClose}
                        TransitionComponent={Fade}
                        PaperProps={{
                            sx: {
                                width: 380,
                                padding: "15px",
                                borderRadius: "14px",
                            },
                        }}
                    >
                        <Typography sx={{ fontWeight: 700, paddingBottom: 1 }}>
                            Categorias
                        </Typography>

                        <MenuItem sx={{ fontWeight: "bold" }} component={Link} to="/produtos">
                            Todos os produtos <FaChevronRight style={{ marginLeft: "auto" }} />
                        </MenuItem>

                        {categories.map((cat) => (
                            <MenuItem
                                key={cat}
                                component={Link}
                                to={`/produtos?categoria=${encodeURIComponent(cat)}`}
                            >
                                {cat}
                                <FaChevronRight style={{ marginLeft: "auto" }} />
                            </MenuItem>
                        ))}

                        <Divider sx={{ my: 1 }} />

                        <Typography sx={{ fontWeight: 700, paddingBottom: 1 }}>
                            Marcas
                        </Typography>

                        {brands.map((brand) => (
                            <MenuItem
                                key={brand}
                                component={Link}
                                to={`/produtos?marca=${encodeURIComponent(brand)}`}
                            >
                                {brand}
                            </MenuItem>
                        ))}

                    </Menu>

                    <Typography
                        component={Link}
                        to="/sobre"
                        sx={{ color: "white", fontWeight: 600, textDecoration: "none" }}
                    >
                        Sobre
                    </Typography>

                    <Typography
                        component={Link}
                        to="/contato"
                        sx={{ color: "white", fontWeight: 600, textDecoration: "none" }}
                    >
                        Contato
                    </Typography>

                    {/* USER DROPDOWN */}
                    <IconButton
                        onClick={(e) => {
                            if (!user) return navigate("/auth");
                            handleUserOpen(e);
                        }}
                        sx={{ color: "white" }}
                    >
                        <FaUserCircle size={24} />
                    </IconButton>

                    <Menu
                        anchorEl={anchorUser}
                        open={Boolean(anchorUser)}
                        onClose={handleUserClose}
                        TransitionComponent={Fade}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        PaperProps={{
                            sx: {
                                width: 260,
                                p: 1,
                                borderRadius: "16px",
                                mt: 1,
                                overflow: "hidden",
                                boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
                                border: "1px solid rgba(255,255,255,0.25)",
                                backdropFilter: "blur(10px)",
                            },
                        }}
                    >
                        {renderUserHeader()}

                        {showAreaCliente && (
                            <MenuItem
                                sx={{
                                    borderRadius: "12px",
                                    py: 1.1,
                                    px: 1.2,
                                    fontWeight: 700,
                                    "&:hover": { bgcolor: "rgba(28,100,242,0.08)" },
                                }}
                                component={Link}
                                to="/minha-conta"
                                onClick={handleUserClose}
                            >
                                Minha Conta
                            </MenuItem>
                        )}

                        {showAreaCliente && (
                            <MenuItem
                                sx={{
                                    borderRadius: "12px",
                                    py: 1.1,
                                    px: 1.2,
                                    fontWeight: 700,
                                    "&:hover": { bgcolor: "rgba(28,100,242,0.08)" },
                                }}
                                component={Link}
                                to="/meus-pedidos"
                                onClick={handleUserClose}
                            >
                                Meus Pedidos
                            </MenuItem>
                        )}

                        {isAdmin && (
                            <MenuItem
                                component={Link}
                                to="/admin"
                                onClick={handleUserClose}
                                sx={{
                                    borderRadius: "12px",
                                    py: 1.1,
                                    px: 1.2,
                                    fontWeight: 900,
                                    color: "rgba(0,0,0,0.75)",

                                }}
                            >
                                Painel Admin
                            </MenuItem>
                        )}

                        <Divider sx={{ my: 1.2, opacity: 0.6 }} />

                        <MenuItem
                            onClick={() => {
                                logout();
                                handleUserClose();
                                window.location.href = "/auth";
                            }}
                            sx={{
                                borderRadius: "12px",
                                py: 1.1,
                                px: 1.2,
                                fontWeight: 800,
                                color: "rgba(0,0,0,0.75)",
                                "&:hover": { bgcolor: "rgba(255,0,0,0.06)", color: "#c62828" },
                            }}
                        >
                            Sair
                        </MenuItem>
                    </Menu>

                    {/* MINI-CART POPOVER */}
                    <IconButton sx={{ color: "white" }} onClick={handleCartOpen}>
                        <Badge badgeContent={cartCount} color="error">
                            <FaShoppingCart size={20} />
                        </Badge>
                    </IconButton>

                    <Popover
                        anchorEl={anchorCart}
                        open={Boolean(anchorCart)}
                        onClose={handleCartClose}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        PaperProps={{
                            sx: {
                                padding: "15px",
                                width: 250,
                                borderRadius: "14px",
                                mt: 1, // pequeno espaçamento do ícone
                            },
                        }}
                    >
                        <Typography sx={{ fontWeight: 700 }}>Seu Carrinho</Typography>
                        <Typography sx={{ color: "gray", fontSize: 14, mt: 1 }}>
                            Você possui {cartCount} itens
                        </Typography>

                        <Button
                            fullWidth
                            variant="contained"
                            sx={{ marginTop: 2 }}
                            component={Link}
                            to="/carrinho"
                        >
                            Visualizar Carrinho
                        </Button>
                        {user ? (
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{
                                    marginTop: 2,
                                    background:
                                        "linear-gradient(135deg, #ff7a00, #ff9a00)",
                                    color: "#fff",
                                }}
                                component={Link}
                                to="/checkout"
                            >
                                Finalizar Compra
                            </Button>
                        ) : false}
                    </Popover>
                </Stack>

                {/* MOBILE MENU BUTTON */}
                <IconButton
                    sx={{ display: { xs: "flex", md: "none" }, color: "white" }}
                    onClick={() => setDrawerOpen(true)}
                >
                    <FaBars />
                </IconButton>

                {/* DRAWER MOBILE */}
                <AnimatePresence>
                    {drawerOpen && (
                        <Drawer
                            anchor="right"
                            open={drawerOpen}
                            onClose={() => setDrawerOpen(false)}
                            PaperProps={{
                                component: motion.div,
                                variants: drawerVariants,
                                initial: "hidden",
                                animate: "visible",
                                exit: "exit",
                                sx: {
                                    width: "100%",
                                    background: "rgba(15, 23, 42, 0.96)",
                                    backdropFilter: "blur(16px)",
                                    borderLeft: "1px solid rgba(255,255,255,0.08)",
                                },
                            }}
                        >
                            <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                                {/* HEADER DRAWER */}
                                <Box
                                    sx={{
                                        px: 2.5,
                                        py: 2,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        borderBottom: "1px solid rgba(255,255,255,0.08)",
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                        <img src={LogoHeader} alt="EMMA" style={{ height: 28 }} />
                                    </Box>

                                    <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: "#fff" }}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>

                                {/* NAV */}
                                <Stack spacing={1.5} sx={{ px: 2.5, py: 3, flex: 1 }}>
                                    {[
                                        { label: "Home", to: "/" },
                                        { label: "Produtos", to: "/produtos" },
                                        { label: "Sobre", to: "/sobre" },
                                        { label: "Contato", to: "/contato" },
                                    ].map((item) => (
                                        <motion.div key={item.label} variants={itemVariants}>
                                            <Button
                                                fullWidth
                                                component={Link}
                                                to={item.to}
                                                onClick={() => setDrawerOpen(false)}
                                                sx={{
                                                    justifyContent: "flex-start",
                                                    color: "#fff",
                                                    fontWeight: 700,
                                                    fontSize: 15,
                                                    px: 2,
                                                    py: 2,
                                                    borderRadius: 2,
                                                    background: "rgba(255,255,255,0.04)",
                                                    border: "1px solid rgba(255,255,255,0.08)",
                                                    "&:hover": {
                                                        background: "rgba(255,255,255,0.08)",
                                                        transform: "translateX(2px)",
                                                    },
                                                }}
                                            >
                                                {item.label}
                                            </Button>
                                        </motion.div>
                                    ))}

                                    {/* CTA */}
                                    <motion.div variants={itemVariants}>
                                        <Button
                                            fullWidth
                                            onClick={() => {
                                                setDrawerOpen(false);
                                                if (!user) return navigate("/auth");
                                                navigate("/minha-conta");
                                            }}
                                            sx={{
                                                mt: 2,
                                                py: 2,
                                                borderRadius: 2,
                                                fontWeight: 900,
                                                background: ORANGE_GRADIENT,
                                                color: "#fff",
                                                boxShadow: "0 8px 30px rgba(255,122,0,0.35)",
                                            }}
                                        >
                                            {user ? "Minha Conta" : "Entrar / Criar conta"}
                                        </Button>
                                    </motion.div>

                                    {user && (
                                        <motion.div variants={itemVariants}>
                                            <Button
                                                fullWidth
                                                component={Link}
                                                to="/meus-pedidos"
                                                onClick={() => setDrawerOpen(false)}
                                                sx={{
                                                    py: 2,
                                                    borderRadius: 2,
                                                    fontWeight: 800,
                                                    color: "#fff",
                                                    background: "rgba(255,255,255,0.08)",
                                                    border: "1px solid rgba(255,255,255,0.12)",
                                                }}
                                            >
                                                Meus Pedidos
                                            </Button>
                                        </motion.div>
                                    )}

                                    {user?.role === "admin" && (
                                        <motion.div variants={itemVariants}>
                                            <Button
                                                fullWidth
                                                component={Link}
                                                to="/admin"
                                                onClick={() => setDrawerOpen(false)}
                                                sx={{
                                                    py: 2,
                                                    borderRadius: 2,
                                                    fontWeight: 800,
                                                    color: "#0f172a",
                                                    bgcolor: "rgba(255,255,255,0.92)",
                                                }}
                                            >
                                                Painel Admin
                                            </Button>
                                        </motion.div>
                                    )}

                                    {/* CARRINHO */}
                                    <motion.div variants={itemVariants}>
                                        <Button
                                            fullWidth
                                            onClick={() => {
                                                setDrawerOpen(false);
                                                navigate("/carrinho");
                                            }}
                                            sx={{
                                                py: 2,
                                                borderRadius: 2,
                                                fontWeight: 900,
                                                color: "#fff",
                                                background: "linear-gradient(135deg, #14b8a6 0%, #06b6d4 100%)",
                                                boxShadow: "0 8px 30px rgba(20,184,166,0.35)",
                                            }}
                                        >
                                            Carrinho ({cartCount})
                                        </Button>
                                    </motion.div>
                                </Stack>
                            </Box>
                        </Drawer>
                    )}
                </AnimatePresence>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
